import { BaseModel } from './base';

export class Trainingtype extends BaseModel {
  trainingTypeName: string;

  subscriberId: string;

  siteId: string;
}
